import React from 'react';
import { emptyList } from './constants';

export default React.createContext({
    getCRSOptions() {
        throw new Error('CountryContext not ready');
    },
    getBostedslandOptions() {
        throw new Error('CountryContext not ready');
    },
    getFodelandOptions() {
        throw new Error('CountryContext not ready');
    },
    getStatsborgerskapOptions() {
        throw new Error('CountryContext not ready');
    },
    getTransaksjonerOptions() {
        throw new Error('CountryContext not ready');
    },
    getNorwegianPostalCodesOptions() {
        throw new Error('CountryContext not ready');
    },
    allCountries: emptyList,
    excludeListe: null,
});
